export const modal = {
  title: 'Are you sure you want to delete this Admin?',
  description:
    'By deleting a Admin, you will permanently delete all of the information, about this Admin. This cannot be undone.',
  confirmText: 'Delete',
  cancelText: 'Cancel',
};
